module.exports = __webpack_public_path__ + "static/fonts/icomoon.d4664875.eot";